import { MenuItem } from './menu.model';
import { permissions } from '../../core/auth/permissions';

export const LOCAL_MENU: MenuItem[] = [
  { id: 'dashboard', label: 'Dashboard', route: '/dashboard', order: 1, roles: permissions.dashboard.read },

  { 
    id: 'projects', label: 'Jobs', order: 2, roles: permissions.project.read, children: [
    { id: 'projects', label: 'Jobs by Crew', route: '/projects/crew', roles: permissions.project.read },  
    { id: 'projects', label: 'Jobs by Customer', route: '/projects/customer', roles: permissions.project.read },       
    { id: 'postjob', label: 'Post Job', route: '/postjob', roles: permissions.postJob.read },
    { id: 'search', label: 'Search Job', route: '/search', roles: permissions.search.read }]},

  { 
    id: 'analysis', label: 'Analysis', order: 4, roles: permissions.analysis.read, children: [
      { id: 'compare', label: 'Water Comparison',  route: '/comparationpage', roles: permissions.compare.read },
      { id: 'summary', label: 'Water Summary', route: '/summarypage', roles: permissions.summary.read, }    ]},

  { 
    id: 'admin', label: 'Administration', order: 10, roles: permissions.admin.read, children: [
      { id: 'audit', label: 'Audit', route: '/audits', roles: permissions.admin.read },
      { id: 'chemical', label: 'Chemicals', route: '/chemicals', roles: permissions.admin.read  },  
      { id: 'crew', label: 'Crews', route: '/crews', roles: permissions.admin.read }, 
      { id: 'customer', label: 'Customers', route: '/customers', roles: permissions.admin.read},
      { id: 'company', label: 'Treatment Company', route: '/companys', roles: permissions.admin.read },
      { id: 'water', label: 'Water Classification', route: '/waterclass', roles: permissions.admin.read }]},
      
  { id: 'about', label: 'About', route: '/about', order: 99, roles: permissions.about.read }];